
export default {
  name: 'public-layout',
  middleware: ['noauth']
}
